import type { MultiSelectReadingPaneProps } from './components/MultiSelectReadingPane';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MultiSelectReadingPane" */ './lazyIndex'),
    { name: 'MultiSelectReadingPane' }
);

export const MultiSelectReadingPane: LazyComponent<MultiSelectReadingPaneProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.MultiSelectReadingPane);
